import { Fragment, type ReactElement } from 'react';
import Skeleton from 'react-loading-skeleton';
import { SpinnerOverlay } from '../spinner';

interface ListSkeletonProps {
  /** Показать спиннер под скелетоном (только при `loading`). */
  showSpinner?: boolean;
  /** Данные грузятся — показываем спиннер (вместе с `showSpinner`). */
  loading?: boolean;
  /** Количество строк-заглушек. По умолчанию 8. */
  rows?: number;
}

/** Скелетон загружающихся данных в таблицу (список заявок, аваркомов и др). */
const ListSkeleton = ({ showSpinner = false, loading, rows = 8 }: ListSkeletonProps) => {
  const printRows = (): ReactElement[] => {
    const items: ReactElement[] = [];
    for (let i = 1;i <= rows;i++) {
      items.push(
        <Fragment key={ `listSk${ i }a` }>
          <div className='col-xs-1'><Skeleton /></div>
          <div className='col-md-11'><Skeleton /></div>
        </Fragment>
      );
    }
    return items;
  };

  const styleHeader = { fontSize: 30, lineHeight: 2 };
  const styleNormal = { fontSize: 25, lineHeight: 2 };

  return (
    <>
      <div className='row' style={ styleHeader }>
        <div className='col-xs-1'><Skeleton /></div>
        <div className='col-xs-3'><Skeleton /></div>
        <div className='col-xs-2'><Skeleton /></div>
        <div className='col-xs-1'><Skeleton /></div>
        <div className='col-xs-2'><Skeleton /></div>
        <div className='col-xs-2'><Skeleton /></div>
        <div className='col-xs-1'><Skeleton /></div>
      </div>
      <div className='row' style={ styleNormal }>
        { printRows() }
      </div>
      <div className='row' style={ styleNormal }>
        <div className='col-md-3'><Skeleton /></div>
        <div className='col-md-2 col-md-offset-7'><Skeleton /></div>
      </div>
      { (showSpinner && loading) && (<SpinnerOverlay loading />) }
    </>
  );
};

export default ListSkeleton;
